export default class BaseGeolocationServiceAPI {
  constructor() {}

  async reverseGeocoding({lat, lon}) {
    throw Error(
      `reverseGeocoding method should be implemented in each subclass of BaseGeolocationServiceAPI: ${this.name} for Lat:${lat}/Lon:${lon}`
    );
  }
}
